import { render, staticRenderFns } from "./InfoSave.vue?vue&type=template&id=59d60f73&"
import script from "./InfoSave.vue?vue&type=script&lang=js&"
export * from "./InfoSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports